import { render } from "./PlaybookContainer.vue?vue&type=template&id=6a4c8bfc&scoped=true"
import script from "./PlaybookContainer.vue?vue&type=script&lang=js"
export * from "./PlaybookContainer.vue?vue&type=script&lang=js"

import "./PlaybookContainer.vue?vue&type=style&index=0&id=6a4c8bfc&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4c8bfc"]])

export default __exports__